import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { get } from 'lodash';

import PageTemplate from 'components/general/PageTemplate';
import { getAdmin } from 'api/admin';
import { refreshReloadPrompt } from 'hooks';
import Admin from './Admin';
import {
  columns,
  suggestionPrimaryKey,
  suggestionSecondaryKeys,
} from './admin.config';

const AccountManagers = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const [modalOpen, setModalOpen] = useState(true);
  const [admin, setAdmin] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [loading, setLoading] = useState(false);
  const [blockRouteChange, setBlockRouteChange] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const fetchAdmin = async () => {
    const { data } = await getAdmin(pageNumber, pageSize);

    setAdmin(data);
    setRowCount(data.pagination.total);
  };

  useEffect(async () => {
    setLoading(true);

    await fetchAdmin();
    setLoading(false);
  }, [pageNumber, pageSize]);

  const handleModalOpen = ({ id }) => {
    history.push(`/admins/${id}`);
    setModalOpen(true);
  };

  const handleModalClose = (save) => {
    if (save && typeof save === 'boolean') {
      console.log('blocking');
      history.block(() => true);
      setModalOpen(false);
    }

    if (!blockRouteChange && !save && typeof save !== 'boolean') {
      setModalOpen(false);
    }

    history.push('/admins');
    fetchAdmin();
    window.removeEventListener('beforeunload', refreshReloadPrompt);
  };

  const handleAdd = () => {
    history.push('/admins/add');
    setModalOpen(true);
    fetchAdmin();
  };

  return (
    <>
      <PageTemplate
        data={get(admin, 'data', [])}
        columns={columns}
        suggestionPrimaryKey={suggestionPrimaryKey}
        suggestionSecondaryKeys={suggestionSecondaryKeys}
        handleModalOpen={handleModalOpen}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        rowCount={rowCount}
        pageNumber={pageNumber}
        pageSize={pageSize}
        loading={loading}
        handleAdd={handleAdd}
        setModalOpen={setModalOpen}
      />

      <Switch>
        <Route path={`${path}/:id`}>
          <Admin
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            blockRouteChange={blockRouteChange}
            setBlockRouteChange={setBlockRouteChange}
          />
        </Route>
      </Switch>
    </>
  );
};
export default AccountManagers;
